import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) navigate(from);
    else setError(r.error);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-[var(--omni-surface)]">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo size="lg" /></div>
        <div className="bg-white border border-[var(--omni-border)] rounded-2xl p-8">
          <h1 className="text-2xl font-bold mb-1">Bon retour</h1>
          <p className="text-sm text-gray-500 mb-6">Connectez-vous à votre compte OmniSearch.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs">Mot de passe</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="login-password-input" />
            </div>
            {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
            <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full bg-[var(--omni-accent)] hover:bg-[var(--omni-accent-hover)] text-white rounded-full">
              {loading ? "Connexion…" : "Se connecter"}
            </Button>
          </form>
          <div className="text-right mt-3">
            <Link to="/forgot-password" className="text-xs text-gray-500 hover:text-black" data-testid="link-forgot-password">
              Mot de passe oublié ?
            </Link>
          </div>
          <div className="text-center text-sm text-gray-500 mt-4">
            Pas encore de compte ? <Link to="/register" className="text-black font-medium" data-testid="link-register">Créer un compte</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
